export default __webpack_public_path__ + "179153d8a7bf23ff44710b5d5addf5fe.svg";